@if (prescriptionsTabVM().isLoading) {
  <ng-lottie [options]="lottieOptions" currentColor class="mx-auto my-auto w-5 text-primary-blue"></ng-lottie>
} @else if (prescriptionsTabVM().prescriptions.length === 0) {
  <div class="typo-h5-book flex h-full items-center justify-center py-1 pl-3">
    {{ 'health_history_prescriptions_tab_empty_text' | translate }}
  </div>
} @else {
  <div class="typo-h5-book flex items-center justify-between py-1 pl-3 pr-2 leading-none text-text-secondary">
    <div class="py-2 pl-2">{{ 'health_history_prescriptions_tab_description_and_name' | translate }}</div>
    <div class="flex">
      <div class="w-[104px] py-2 pl-2">{{ 'health_history_prescriptions_tab_prescriber' | translate }}</div>
      <div class="w-32 py-2 pl-2">{{ 'health_history_prescriptions_tab_prescribe_date' | translate }}</div>
      <div class="w-11 py-2 pl-2" [libUiTooltip]="nsTooltip" [tooltipPosition]="'bottom'">
        {{ 'health_history_prescriptions_tab_ns' | translate }}
      </div>
    </div>
  </div>
  <ng-template #nsTooltip>
    <div class="px-3 py-2">
      <div class="typo-h7-light">{{ 'health_history_prescriptions_tab_ns_tooltip' | translate }}</div>
    </div>
  </ng-template>
  <div class="flex flex-1 flex-col gap-2 overflow-y-auto">
    @for (item of prescriptionsTabVM().prescriptions; track item.id) {
      <lib-prescriptions-item [item]="item"></lib-prescriptions-item>
    }
  </div>
}
